import { useState } from 'react'
import Card from '../ui/Card'
import ProductModal from './ProductModal'
import formatGBP from '../../utils/formatGBP'

interface ProductCardProps {
	images: any
	vendor: string
	title: string
	handle: string
	description: string
	variants: any
	className?: string
	skeletonClassName: string
}

const ProductCard = ({
	images,
	vendor,
	handle,
	title,
	variants,
	description,
	className,
	skeletonClassName
}: ProductCardProps) => {
	const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)
	const [loading, setLoading] = useState(true)

	return (
		<>
			{/* NOTE: use display flex at the top level to prevent safari from breaking image and card when using columns css  */}
			<div className="flex">
				<ProductModal
					show={show}
					handleClose={handleClose}
					images={images}
					vendor={vendor}
					title={title}
					handle={handle}
					description={description}
					variants={variants}
				/>

				<Card className={`w-full !overflow-hidden ${className}`} onClick={handleShow}>
					<div className="relative">
						{loading && <div className={`skeleton ${skeletonClassName} absolute inset-0`} />}

						<img
							src={images?.edges?.[0]?.node?.src}
							alt={title}
							className="h-[300px] w-full bg-[#d0dae6] object-cover"
							loading="eager"
							onLoad={() => setLoading(false)}
						/>
					</div>
					<div className="min-h-[70px] px-4 pb-6 pt-4">
						<p className="text-dark mb-1 text-xl font-semibold">{title}</p>
						<p className="text-xl">{formatGBP(variants?.edges?.[0]?.node?.price?.amount)}</p>
					</div>
				</Card>
			</div>
		</>
	)
}

export default ProductCard
